var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"setting.invoice.label","bread-crumb-data":_vm.breadCrumbData}},[_c('invoice-series-table'),_c('invoice-config-info-box')],1)}
var staticRenderFns = []

export { render, staticRenderFns }